import PropTypes from "prop-types";
import clsx from "clsx";

const SectionTitleWithText = ({ title, subtitle, desc, spaceTopClass, spaceBottomClass }) => {
    return (
        <div className={clsx("welcome-area", spaceTopClass, spaceBottomClass)}>
            <div className="container">
                <div className="welcome-content text-center">
                    <h5>{title}</h5>
                    <h1>{subtitle}</h1>
                    <p>
                        {desc}
                    </p>
                </div>
            </div>
        </div>
    );
};

SectionTitleWithText.propTypes = {
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
};

export default SectionTitleWithText;
